import React from 'react';

type LegalParagraphProps = {
  children: React.ReactNode;
};

export function LegalParagraph({ children }: LegalParagraphProps) {
  return <p className="text-gray-600">{children}</p>;
}
